module.exports = "<div class=\"overviewSubscriptionPlan\">\n    <div class=\"flex flex-justify-content ng-scope\">\n        <div class=\"flex-column\">\n            <sub>Resource Usage</sub>\n        </div>\n    </div>\n    <div class=\"flex flex-wrap flex-center\">\n        <as-doughnut-chart donut=\"$ctrl.chart1\"></as-doughnut-chart>\n        <as-doughnut-chart donut=\"$ctrl.chart2\"></as-doughnut-chart>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/license/features/license-subscription-plan/licenseSubscriptionPlan.component.html
// module id = 626
// module chunks = 0